
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { InputType } from '@/enums/InputType';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import StackedForm from '../../../mixins/StackedForm';
import moment from 'moment';

@Component({
  components: { VFormBuilder },
})
export default class PanicForm extends mixins(StackedForm) {
  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get initVals() {
    return (this.initialValues as any) || {};
  }

  get isPanicActive() {
    const end = this.initVals.panicEndAt;

    if (!end) {
      return false;
    }

    return moment(end).isSameOrAfter(moment());
  }

  get items() {
    return [
      { name: 'panicEndAt', type: InputType.DateTime, label: 'venue.form.panicEndAt' },
      {
        name: 'panicReason',
        type: InputType.Text,
        label: 'venue.form.panicReason',
        rules: this.isPanicActive ? 'required' : '',
      },
    ];
  }
}
